import { ReactNode } from "react";

import { Button, Center, Grid } from "@mantine/core";
import BoxContainer from "~/../../base-components/lib/BoxContainer";
import { PencilFill } from "~/../../base-components/lib/assets/icons.generated";
import { SECONDARY_COLOR } from "~/../../base-components/lib/theme/button";
import { UTILITY_COLOR } from "~/../../base-components/lib/theme/colors";

export default function PreviewCollectionTile({
  image,
  title,
  subtitle,
  onEdit,
}: {
  image: ReactNode;
  title: ReactNode;
  subtitle: ReactNode;
  onEdit: () => void;
}) {
  return (
    <BoxContainer>
      <Grid align="center" justify="space-between">
        <Grid.Col span="content">
          <Center
            w={68}
            h={68}
            bg={UTILITY_COLOR.TABLE_ROW_BACKGROUND}
            sx={(theme) => ({
              border: `1px solid ${theme.colors.divider[0]}`,
              overflow: "hidden",
              borderRadius: theme.radius.sm,
            })}
          >
            {image}
          </Center>
        </Grid.Col>
        <Grid.Col span="auto">
          {title}

          {subtitle}
        </Grid.Col>
        <Grid.Col span="content">
          <Button
            color={SECONDARY_COLOR}
            onClick={onEdit}
            leftIcon={<PencilFill />}
          >
            Edit
          </Button>
        </Grid.Col>
      </Grid>
    </BoxContainer>
  );
}
